import ModelUtil from '@leverege/model-util';
import I18N from '@leverege/i18n';
import GeoLayerModel from "../../dataViewers/map/mapbox/renderers/GeoLayerModel.js";
const TYPE = 'molten.mapRenderer.GroupingsModel';
const {
  tf
} = I18N.ns('molten.groupings.map.GroupingsModel');

/**
 * This represents geo tile group that has geo tiles
 */
function create(layerName, name, objectType) {
  return {
    ...GeoLayerModel.create(layerName, name, objectType),
    type: TYPE,
    name: name || tf('unknownLayer'),
    visible: false,
    layerName,
    objectType
  };
}
export default {
  ...GeoLayerModel,
  TYPE,
  create,
  getObjectType: m => m.objectType,
  ...ModelUtil.createAllValue('visible')
};